var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import * as React from "react";

function SvgShSearch(props) {
  return React.createElement(
    "svg",
    _extends({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 13.94 13.942"
    }, props),
    React.createElement("path", { d: "M13.75 12.054l-2.714-2.715a.653.653 0 00-.463-.191h-.444a5.661 5.661 0 10-.98.98v.444a.653.653 0 00.191.463l2.715 2.715a.651.651 0 00.923 0l.771-.771a.657.657 0 00.001-.925zM5.663 9.149a3.485 3.485 0 113.486-3.486 3.483 3.483 0 01-3.486 3.486z" })
  );
}

export default SvgShSearch;